import * as React from 'react';

import * as styles from './RecommendedPackageLayout.css';

interface IProps {
  recommendedPackage: React.ReactElement;
  recommendedPackageHint: React.ReactElement;
}

export const RecommendedPackageLayout = ({ recommendedPackage, recommendedPackageHint }: IProps) => (
  <div className={styles['layout']}>
    {recommendedPackage}
    {recommendedPackageHint}
  </div>
);
